export function Logo({ size = 28 }: { size?: number }) {
  return (
    <span className="logo">
      <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
        <rect width="32" height="32" rx="7" fill="var(--accent)" />
        <path d="M8 10.5h16v11H8z" fill="none" stroke="#fff" strokeWidth="2" strokeLinejoin="round" />
        <path d="m8 11 8 6 8-6" fill="none" stroke="#fff" strokeWidth="2" strokeLinejoin="round" />
      </svg>
      <span className="logo-text">ccnote</span>
    </span>
  );
}
